<style lang="less" scoped>
* {list-style-type: none;}
ul, li {margin: 0;padding: 0;}
.Hyxq_wq {position: relative;width: 100%;display: flex;flex-direction: column;justify-content: center;align-items: center;margin: 0;padding: 0;background: #fff;font-family: AlibabaPuHuiTi-Medium;margin-bottom: 60px;}
.national {width: 1200px;}
.photo {width: 100%;overflow: hidden;
  img {width: 100%;overflow: auto;user-select: none;height:100%;display: block;}
  #downup {font-weight: bolder;font-size: 20px;color: #fff;position: relative;top: -20px;}
  #downup:hover {cursor: pointer;}
  .text {overflow:hidden;background: linear-gradient(to top, #1877CB 0%,#115290 100%);
    .bottom {width: 1200px;line-height: 16px;margin: 0px auto;height: 100px;
      .content {font-size: 18px;letter-spacing: 1px; overflow: hidden;color: #fff;display: inline-block;height: 60%;text-align: left;margin-top: 20px;line-height: 30px;text-indent: 2em;}
    }
  }
}
.dhnews {width: 1190px;margin: auto;display: flex;flex-direction: column;height: 580px;
  p {line-height: 50px;font-size: 20px;font-weight: 600;letter-spacing: 3px;display: flex; flex-direction: column;
    i {width: 50px; height: 3px;display: inline-block;background: #3c77bb;margin: auto; }
  }
}
.details {display: flex;justify-content: space-between;padding: 0;margin-left:-10px;
  li {border: 1px solid #d9d9d9;width: 28%;height: 410px;display: flex;flex-direction: column;box-shadow: darkgrey 10px 10px 30px 5px;border-radius: 10px;cursor: pointer;
    img{width: 100%; height: 188px;}
    h3 {text-align: left;padding: 0 10px; }
    span {color: #9f9f9f;padding: 0 10px;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 4;-webkit-box-orient: vertical;text-align: left;line-height: 24px;}
  }
}
.dhyc {width: 1200px;display: flex;flex-direction: column;
  p {line-height: 50px;font-size: 20px;font-weight: 600;letter-spacing: 3px;display: flex;flex-direction: column;
    i {width: 50px;height: 3px;display: inline-block;background: #3c77bb;margin: auto;}
  }
}
.dhzb {width: 1200px;display: flex;flex-direction: column;margin-top: 40px;
  p {line-height: 50px;font-size: 20px;font-weight: 600;letter-spacing: 3px;display: flex;flex-direction: column;
    i {width: 50px;height: 3px;display: inline-block;background: #3c77bb;margin: auto;}
  }
}
.message{width: 1200px;margin: auto;display: flex;flex-wrap:wrap;margin-bottom: 60px;}
.first{width: 266px; height: 250px;margin-left: 40px;margin-top: 20px;}
.first:nth-child(4n+1){margin-left: 0px;}
.first:hover{cursor: pointer;}
.pic img{width: 266px;height: 150px;}
.title span{margin-top:5px;line-height:25px;text-align: left;color:#666666;overflow: hidden;-webkit-line-clamp: 2;text-overflow: ellipsis;display: -webkit-box;-webkit-box-orient: vertical;}
.time span{margin-top:15px;width:177px;height:25px;display: flex;text-align: left;color:#856404;font-weight: bold;background-color: #fdeebe;}
.chbm{position: relative;width: 1200px;margin: auto;display: flex;flex-direction: column;
  .baoming{text-align: left;font-size: 15px;margin: 0px;}
  .checkbox1{position: absolute;left:0px;top:390px;font-size: 13px;font-weight: 600;}
  .checkbox2{position: absolute;left:0px;top:430px;font-size: 13px;font-weight: 600;}
  .button{margin-top: 60px;
    .button1{float: right;}
    .button2{float: right;margin-right: 40px;}
  }
}
</style>

<template>
  <div class="Hyxq_wq">
    <div class="photo" id="photo">
      <img src="static/images/zlkindex/lt.jpg" alt="" />
      <div class="text" id="text">
        <div class="bottom">
          <span class="content">{{introduce}}</span>
        </div>
      </div>
      <i class="el-icon-arrow-down" id="downup" @click="downup()"></i>
    </div>
    <div class="dhyc" id="hyrc">
      <p>
        <span>大会议程</span>
        <i></i>
      </p>
      <AgendaTabs class="agenda" :TabsList="TabsList"></AgendaTabs>
    </div>
    <div class="dhyc" id="hyrc">
      <p>
        <span>参会报名</span>
        <i></i>
      </p>
      <div class="chbm">
        <p class="baoming">姓名</p>
        <el-input v-model="name"></el-input>
        <p class="baoming">单位</p>
        <el-input v-model="company"></el-input>
        <p class="baoming">手机号</p>
        <el-input v-model="telephone"></el-input>
        <p class="baoming">参会人数</p>
        <el-input v-model="num"></el-input>
        <div class="button">
          <el-button type="primary" class="button1" @click="downLoad('static/pdf/han.pdf')">邀请函下载</el-button>
          <el-button type="primary" class="button2" @click="submit">提交</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 何宽 会议详情召开中页面
 */
import filters from '../method/filter.js'
import AgendaTabs from '../../app/assembly/AgendaTabs'
import SwiperCard from '../assembly/SwiperCard'
import arrayFun from '../method/array.js'
export default {
  components: {AgendaTabs, SwiperCard},
  mixins: [filters],
  data()
  {
    return {
      swiperSFQList: [],
      newslist: [],
      TabsList: [],
      zblist: [],
      name: '',
      company: '',
      telephone: '',
      num: '',
      introduce: ''
    }
  },
  watch:
  {
    $route: {
      handler(nval, oval)
      {
        this.getSub(+nval.query.id)
        this.getHyrc(+nval.query.id)
      },
      immediate: true
    }
  },
  created()
  {
    this.getNews()
    this.getData()
  },
  methods: {
    // 下滑文字
    getSub(num)
    {
      let paras = {cmd: 'query', _major: 11, _minor: 53, _exp: 'id=?', types: 'i', vals: num}
      window.post.getPost(paras).then((ret) =>
      {
        this.introduce = ret[0].introduce
      })
    },
    //大会资讯
    getNews()
    {
      let paras = {cmd: 'query', _major: 11, _minor: 50, _exp: 'id>0 and examine = 0', orderby: 'addtime DESC', init: 0, pageno: 1, pagesize: 5}
      window.post.getPost(paras).then((ret) =>
      {
        this.newslist = ret[0].data
      })
    },
    //获取会议日程数据
    getHyrc(num)
    {
      let paras = {cmd: 'query', _major: 11, _minor: 34, _exp: `catid=${num}`, orderby: 'id DESC'}
      window.post.getPost(paras).then((ret) =>
      {
        let temp = []
        temp.push({id: '0', title: ret[0].data, content: []})
        for (let i = 1; i < ret.length; i++)
        {
          if (ret[i].data !== ret[i - 1].data)
            temp.push({id: i.toString(), title: ret[i].data, content: []})
        }
        for (let i = 0; i < temp.length; i++)
        {
          for (let j = 0; j < ret.length; j++)
          {
            if (ret[j].data === temp[i].title)
              temp[i].content.push({id: ret[j].id, time: ret[j].times, arrangement: ret[j].content})
          }
          temp[i].content = temp[i].content.sort(arrayFun.compareStoB('id'))
        }
        this.TabsList = temp
      })
    },
    //大会直播
    getData()
    {
      let paras = {cmd: 'query', _major: 11, _minor: 7,  _exp: 'id>? and examine = 0', types: 'i', vals: '0', init: 0, pageno: 1, pagesize: 20}
      window.post.getPost(paras).then((ret) =>
      {
        let arr = []
        ret[0].data.forEach(item =>
        {
          arr.push({id: item.id, pic: item.thumb ? item.thumb : 'static/images/moren.jpg', title: item.title, time: item.starttime})
        })
        this.zblist = arr
      })
    },
    downup()
    {
      let dom = document.getElementsByClassName('bottom')[0]
      let dom1 = document.getElementsByClassName('content')[0]
      let downup = document.getElementById('downup')
      let speed = dom.offsetHeight
      let speed1 = dom1.offsetHeight
      if (downup.className === 'el-icon-arrow-down')
      {
        let timer
        clearInterval(timer)
        timer = setInterval(function()
        {
          if (speed >= 190 && speed1 >= 80)
          {
            speed = 190
            speed1 = 80
            downup.classList.remove('el-icon-arrow-down')
            downup.classList.add('el-icon-arrow-up')
            dom.style.height = speed + 'px'
            dom1.style.height = speed1 + '%'
            clearInterval(timer)
          }
          else
          {
            speed += 2
            speed1 += 2
            dom.style.height = speed + 'px'
            dom1.style.height = speed1 + '%'
          }
        }, 20)
      }
      else if (downup.className === 'el-icon-arrow-up')
      {
        let timer
        clearInterval(timer)
        timer = setInterval(function()
        {
          if (speed <= 100 && speed1 <= 60)
          {
            speed = 100
            speed1 = 60
            downup.classList.remove('el-icon-arrow-up')
            downup.classList.add('el-icon-arrow-down')
            dom.style.height = speed + 'px'
            dom1.style.height = speed1 + '%'
            clearInterval(timer)
          }
          else
          {
            speed -= 2
            speed1 -= 2
            dom.style.height = speed + 'px'
            dom1.style.height = speed1 + '%'
          }
        }, 20)
      }
    },
    // 报名参会
    submit()
    {
      let obj = {
        cmd: 'add',
        _major: 11,
        _minor: 55,
        retAtt: 1,
        catid: 2,
        name: this.name,
        company: this.company,
        telephone: this.telephone,
        num: this.num,
        type: '线上云展',
        page: 2,
        addtime: (Date.parse(new Date()) / 1000)
      }
      window.post.getPost(obj).then(ret =>
      {
        if (ret.ret === 0)
          this.$message({message: '报名成功', type: 'success', customClass: 'mzindex'})
      })
      this.name = ''
      this.company = ''
      this.telephone = ''
      this.num = ''
    },
    // 下载邀请函
    downLoad(router)
    {
      window.open(router, '_blank')
    },
    // 跳转到资讯动态详情页面
    goDetails(item)
    {
      let url = this.$router.resolve({path: '/HyxqDetails', query: {id: item.id}})
      window.open(url.href, '_blank')
    },
    // 跳转到直播页面
    goLtzb(item)
    {
      let url = this.$router.resolve({path: '/Ltzb', query: {id: item.id}})
      window.open(url.href, '_blank')
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/plugins/app/project/Hyxqzk.vue